import type { FooterLink } from './FooterTypes';

// Utility functions

export function slugify(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/['’]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function resolveFooterHref(link: FooterLink): string | undefined {
  if (link.href === '#') return undefined;
  if (link.href && link.href.trim() !== '') return link.href;
  return undefined;
}

export function isExternalHref(href: string): boolean {
  return /^https?:\/\//i.test(href);
}
